import { atom } from 'recoil';

export const callBackModalAtom = atom({
  key: 'callBackModalAtom',
  default: {
    value: false,
    productId: 0,
  },
});
